var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgStar1 = function SvgStar1(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2058 24.8786L42.2029 1.75722L45.4493 3.05202L35.8029 25.9884L53.2406 8.13873L55.8377 10.6358L37.9362 28.0231L60.8464 18.2196L62.2377 21.3642L38.9565 30.6127L64 30.1503V33.7572L38.9565 33.2948L62.2377 42.6358L60.8464 45.8728L37.9362 35.6994L55.8377 53.3642L53.5188 55.8613L35.8029 37.6416L46.0058 60.8555L42.7594 62.1503L33.2058 38.659L33.7623 64H30.3304L30.6087 38.659L21.6116 62.1503L18.2725 60.8555L28.0116 37.6416L10.5739 55.8613L8.06959 53.3642L26.1565 35.6994L2.96811 45.8728L1.66957 42.6358L25.229 33.2948L0 33.7572V30.6127H25.229L1.66957 21.3642L2.96811 18.2196L26.1565 28.0231L8.06959 10.6358L10.5739 8.13873L28.0116 25.9884L17.9942 3.05202L21.2406 1.75722L30.3304 24.8786V0H33.7623L33.2058 24.8786Z",
    fill: "currentColor"
  })));
};

export default SvgStar1;